export interface IMediaStreamAudioSourceOptions {
    mediaStream: MediaStream;
}
